export enum UserStatus {
  Inactive = "active",
  Active = "active",
  Blocked = "blocked",
  Deleted = "deleted",
  New = "new",
}
